import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { mergeMap, withLatestFrom } from 'rxjs/operators';
import AppState from '@webapp/store/state';
import {
  CreateCollaborator,
  CreateCollaboratorSuccess,
} from '@webapp/store/collaborator/action-creators';
import { CREATE_COLLABORATOR_SUCCESS } from '@webapp/store/collaborator/actions';
import { trackList } from '@webapp/store/tracks/selectors';
import { Action } from 'redux';
import { NewCollaborator } from '@services/collaborator/types/new-collaborator';

export const createCollaboratorForOtherTracksEpic = (
  action$: Observable<CreateCollaboratorSuccess>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType(CREATE_COLLABORATOR_SUCCESS),
    withLatestFrom(state$),
    mergeMap(([action, state]) => {
      const tracks = trackList(state.tracks.tracks, state.release.release?.id);
      const isFirstTrack =
        tracks.findIndex((t) => t.id === action.collaborator.assetId) === 0;
      const actions: Action[] = [];
      if (
        action.collaborator.collaboratorId &&
        action.collaborator.role &&
        isFirstTrack &&
        !state.tracks.disableReplicateCollaborators
      ) {
        const allAssets = state.collaborator.assets;
        const assets = Object.entries(allAssets).reduce((acc, [key, value]) => {
          if (tracks.find((track) => track.id === key)) {
            acc[key] = value;
          }
          return acc;
        }, {} as typeof allAssets);
        Object.keys(assets).forEach((key) => {
          if (key !== action.collaborator.assetId) {
            const newcollaborator: NewCollaborator = {
              ...action.collaborator,
              assetId: key,
            };
            actions.push(new CreateCollaborator(newcollaborator));
          }
        });
      }
      return actions;
    })
  );
